export default {
  upload_common: {
    required: '必須項目です。',
    max_length_500: '５００文字以下でなければなりません。',
    please_enter_a_number: '数字を入力してください。',
    unexpected_error: '予期せぬエラーが発生しました。',
    temporarily_saved: '一時保存されました。',
    unanswered_items: '未回答の項目があります。',
    answer_questionnaire_select: '回答する調査票/サーベイを選択してください',
    entry: '記入してください。',
    target_select: '選択してください。',
    value_unit: '値',
    unit: '単位',
    attach_documents: '資料を添付する',
    textarea_placeholder:
      '※記述が求められている場合、または補足を記載される場合はこちらに記載ください。',
    textarea_placeholder_with_file:
      '※添付している証憑の該当ページを記入してください。\nまた、記述が求められている場合や、補足を記載される場合はこちらに記載ください。',
    temporary_storage: '一時保存',
    submit: '提出する',
    last_saved_temporary: '最終下書き保存日時',
    There_are_unanswered_questions: '未回答の項目があります',
    submitted_text: 'この調査票/サーベイは提出されています。',
    submitted_at: '提出日時',
    withdrawal_of_answer: '回答取り下げ',
    withdrawal_accepted: '回答が差し戻しされました',
    help: 'ヘルプ',
    example_of_evidence: '証憑例',
    save_temporary_answer: '調査票/サーベイを一時保存する',
    saved_temporary_answer: '回答内容が一時保存されました。',
    submit_answer: '調査票/サーベイを提出する',
    confirm_submit_answer: '回答中の調査票/サーベイを提出してよろしいですか？',
    recommend_asuene: '「アスエネESG」を他社に薦めたいと思いますか？',
    not_at_all: '全く思わない',
    absolutely: '非常に思う',
    let_us_know_your_thoughts: 'ご意見やご感想があればお聞かせください。',
    thank_you_for_your_cooperation: 'ご協力ありがとうございました。\nいただいたご意見はサービス改善の参考にさせていただきます。\n\n引き続きよろしくお願いいたします。',
    confirm_submit_shared_text: '\n回答の内容は調査依頼企業に共有されます。',
    complete_submit_answer: '調査票/サーベイが提出されました。\nご協力ありがとうございました。',
    back_answer: '回答に戻る',
    close: '閉じる',
    save_temporary_answer_and_prev: '保存して前へ',
    save_temporary_answer_and_next: '保存して次へ',
    prev: '前へ',
    next: '次へ',
    question_group_question_download: '設問ダウンロード',
    question_group_answer_download: '回答ダウンロード',
    question_group_download_answer_csv_title: '設問・回答(CSV)',
    question_group_download_answer_csv_description: 'CSVで回答がダウンロードされます',
    question_group_download_answer_pdf_title: '設問・回答(PDF)',
    question_group_download_answer_pdf_description: 'PDFで回答がダウンロードされます',
    question_group_download_scorecard_pdf_title: 'スコアカード(PDF)',
    question_group_download_scorecard_pdf_description: 'PDFでスコアがダウンロードされます',
    question_group_download_esg_award_svg_title: 'ESGアワード(SVG)',
    question_group_download_esg_award_svg_description: 'SVGでアワードがダウンロードされます',
    question_group_download_esg_award_pdf_title: 'ESGアワード(PDF)',
    question_group_download_esg_award_pdf_description: 'PDFでアワードがダウンロードされます',
    request_survey_withdrawal: '回答の取り下げを依頼する',
    survey_withdrawal_description: '回答の取り下げを評価依頼企業へ依頼します。\n取り下げを希望する理由を下記に記載し、送信してください。内容は評価依頼企業へ表示されます。',
    reason_withdrawal_request: '取り下げ希望理由',
    completed_withdrawal_request: '回答の取り下げを依頼しました。\n差し戻しされるまで、少々お待ちください。',
    send: '送信する',
    cancel: 'キャンセル',
    balloon_title_withdrawal_request: '回答の取り下げを依頼しました。',
    no_survey: '調査票/サーベイの回答依頼はありません。',
    failed_to_save_before_export: 'ダウンロード前の一時保存に失敗しました。入力内容に不備がないかご確認ください。',
    filter_unfilled_questions: '未回答のみ表示する',
    no_unfilled_questions: '未回答の設問はありません。',
    move_page: 'ページを移動する',
    confirm_move_page_message: '回答内容は保存されていません。\nこのまま移動するとデータが失われます。保存してから移動しますか？',
    confirm_without_save: '保存せずに移動',
    confirm_with_save: '保存して移動',
    error_save: '一時保存ができませんでした。入力内容を確認ください。',
    there_are_no_unanswered_questions: 'すべての設問に回答しました。',
    someone_editing_survey: '編集中の調査票/サーベイ',
    unable_edit_someone_editing_survey: 'この調査票/サーベイを回答中のユーザーがいるため、現在編集できません。',
    user_editing_survey: 'さんが編集中',
    reference_question: {
      see_previous_answers: '過去回答を参照',
      previous_answers: '過去の回答内容',
      overwrite_with_previous_answers: '過去回答で上書き',
      submitted_at: '（{submitted_at} 提出）',
      related_question: '{target}を参照',
      click_to_expand: 'クリックして展開',
      click_to_omit: 'クリックして省略',
      description: '過去に提出した調査票/サーベイの回答をコピーすることができます。「上書き」をクリックすると、調査票/サーベイに過去回答が紐づけられている場合に、回答が自動入力されます。入力された回答がある場合は上書きされます。',
      answer_reference_function: '回答引き継ぎ機能',
      overwrite: '上書き',
      overwrite_confirm: '回答中の調査票/サーベイに過去回答を自動入力します。\n入力された回答がある場合は上書きされます。',
      question_group: '@:question_group_section.list_header_question',
    },
    energy_question: {
      scope: 'Scope',
      item: '項目',
      activity_amount: '活動量',
      emission_factor: '排出係数',
      emission_amount: '排出量',
      unit_sale: '売上高原単位',
      total: '合計',
      emission_amount_unit: 'tCO2',
      unit_sale_unit: 'tCO2/百万円',
    },
    label: {
      required_answer: '必須回答',
      optional_answer: '任意回答',
      conditional_required_answer: '条件必須回答',
      note: '備考',
      evidence_attachments: '証憑添付',
    },
    no_available_in_pdf: 'この設問はPDF出力の対象外です。',
    comparison_question_meta: '「{categoryName}」の{questionDisplayNumber}問目の回答',
    comparison_reference_question_meta: '「調査票「{questionGroupName}」の「{categoryName}」カテゴリの質問No.{questionDisplayNumber}',
    error_footer: '未修正の項目があります。',
    error_panel_title: '修正箇所を確認',
    error_panel_description: '以下の設問を修正して、提出を完了させましょう。',
    error_panel_support_text_1: '問題が解決しない場合は、',
    error_panel_support_label: 'サポート',
    error_panel_support_text_2: 'までご連絡ください。',
    error_panel_resolved: 'すべてのエラーが解消されました。提出できます。',
    error: 'エラー',
    error_revision_required: '提出のために修正が必要です。',
    alert: 'アラート',
    alert_detected: '推奨値から離れていますが、提出可能です。',
    share_answer: {
      share_button: '回答を共有',
      modal_title: '回答を共有する',
      description: '共有相手のメールアドレスを入力してください。登録すると、閲覧用のURLとパスワードが送付されます。',
      no_sharing_email: '共有中のメールアドレスはありません。',
      unshare: '共有を解除する',
      not_shared: '{emails}への共有が、まだ完了していません。',
      confirm_share_answer: 'メールアドレスを登録してよろしいですか？',
      close_without_share: '登録せずに閉じる',
      close_with_share: '登録して閉じる',
      not_register: '@:evaluation_dashboard.answer_transition.unregistered',
      confirm_unshare: '{email}を削除して、共有を解除してよろしいですか？',
      shared: '回答を共有しました。',
    },
    question_group_download_answered_csv_title: '設問・回答(CSV)',
    question_group_download_answered_pdf_title: '設問・回答(PDF)',
    nps_reason: {
      question_text: 'その理由を教えてください。（複数選択可）',
      options: {
        content_not_suitable: '内容が自社に合わない',
        too_many_questions: '設問が多い・複雑',
        insufficient_support: 'サポートが不十分',
        hard_to_understand: '表示がわかりにくい',
        difficult_operation: '操作や入力がしづらい',
        slow_operation: '動作が遅い',
        other: 'その他',
      },
    },
    hide_conditional_questions: {
      modal: {
        title: '回答不要の設問を非表示',
        description: '一部の設問は、選択された内容により回答不要となっております。\n回答不要の設問を非表示にしますか？',
        submit: '設定',
        checkbox_label: '次回から回答不要の設問を非表示',
      },
    },
  },
}
